var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"fab":"","loading":_vm.loading,"color":_vm.$store.getters.isThemeDark
      ? 'white accent-4 black--text'
      : 'blue darken-4 white--text'},on:{"click":function($event){return _vm.googleSignIn()}}},[_c('v-img',{attrs:{"max-width":"2rem","contain":true,"src":"/img/google.logo.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }